import { useQuery } from '@tanstack/react-query';

import { FinanceAccountNumberResource } from '@/types/resources';
import { api } from '@/utils/api';

const useAccountNumbersOptions = () => {
  return useQuery(
    ['finance-account-numbers'],
    () =>
      api.get<never, FinanceAccountNumberResource[]>(
        '/v1/finance-account-numbers',
      ),
    {
      select: (data) =>
        data.map((item) => ({
          value: item.id,
          label: item.name,
        })),
      staleTime: 5 * 60 * 1000,
    },
  );
};

export default useAccountNumbersOptions;
